import { Component, OnInit } from '@angular/core';
import { EpgItem } from '../../../data/btv/model/epg-item';
import { DatePipe } from '@angular/common';
import { BtvDataRestService } from '../../../data/btv/btv-data-rest.service';

@Component({
  selector: 'app-tv-guide',
  templateUrl: './tv-guide.component.html',
  styleUrls: ['./tv-guide.component.css']
})
export class TvGuideComponent implements OnInit {

  epgDatas: EpgItem[] = [];
  selectedDate: string = "2019-01-22";
  selectedDay: string;
  timeSlot: any[] = ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"]

  constructor(
    private btvService: BtvDataRestService,
    private datePipe: DatePipe
  ) {
   }

  ngOnInit() {
    this.selectedDay = this.datePipe.transform(this.selectedDate, 'EEEE');
    this.getDailyEpgs()

  }

  getDailyEpgs() {
    this.btvService.getDailyEpgs(this.selectedDate).subscribe(data => {
      this.epgDatas = data;
    })
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/btv/tv-guide/tv-guide.component.ts